module.exports = __webpack_public_path__ + "static/img/technology01.f20da737.png";